import { Widget, string, mk_widget, IOWidget } from 'widgets-for-react'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { HeaderBlock } from '../blocks/custom_blocks/widgets/headerBlock.mod';
import { CMSState } from '../../cms/blocks/types.gen';
import { PublicSiteState } from '../../public_site.main.mod';
import { createButtonData } from '../../../utils';

export const notfound_page: IOWidget<PublicSiteState, never> = (public_state:PublicSiteState) => mk_widget({
  run: o => (

    <div className="error-wrapper">
      {HeaderBlock({
        blockName: 'vidda/header',
        title: t('404.title'),
        intro: t('404.description'),
        primary_button: createButtonData(t('404.homepage'),t('404.link')),
        // TODO - Set correct header type
        header_type: 'header one'
      }, { style: {} })({} as CMSState<{}, {}, never>)(public_state).run(_ => {})}
    </div>

  )
})
